module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/cash.png", __webpack_public_path__ + "_/_/_/common/components/mobile/images/cash.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/cash.png
// module id = 607
// module chunks = 2